const states = [
  { name: "Andaman and Nicobar", code: "35" },
  { name: "Andhra Pradesh", code: "37" },
  { name: "Arunachal Pradesh", code: "12" },
  { name: "Assam", code: "18" },
  { name: "Bihar", code: "10" },
  { name: "Chandigarh", code: "4" },
  { name: "Chhattisgarh", code: "22" },
  { name: "Dadra and Nagar Haveli", code: "26" },
  { name: "Daman and Diu", code: "25" },
  { name: "Delhi", code: "7" },
  { name: "Goa", code: "30" },
  { name: "Gujarat", code: "24" },
  { name: "Haryana", code: "6" },
  { name: "Himachal Pradesh", code: "2" },
  { name: "Jammu and Kashmir", code: "1" },
  { name: "Jharkhand", code: "20" },
  { name: "Karnataka", code: "29" },
  { name: "Kerala", code: "32" },
  { name: "Ladakh", code: "38" },
  { name: "Lakshadweep", code: "31" },
  { name: "Madhya Pradesh", code: "23" },
  { name: "Maharashtra", code: "27" },
  { name: "Manipur", code: "14" },
  { name: "Meghalaya", code: "17" },
  { name: "Mizoram", code: "15" },
  { name: "Nagaland", code: "13" },
  { name: "Odisha", code: "21" },
  { name: "Other Territory", code: "97" },
  { name: "Other Countries (Registered)", code: "96" },
  { name: "Other Countries (Unregistered)", code: "99" },
  { name: "Puducherry", code: "34" },
  { name: "Punjab", code: "3" },
  { name: "Rajasthan", code: "8" },
  { name: "Sikkim", code: "11" },
  { name: "Tamil Nadu", code: "33" },
  { name: "Telangana", code: "36" },
  { name: "Tripura", code: "16" },
  { name: "Uttar Pradesh", code: "9" },
  { name: "Uttarakhand", code: "5" },
  { name: "West Bengal", code: "19" }
];

export default states;
